import { render, staticRenderFns } from "./SLBreakup.vue?vue&type=template&id=6a12d0bc&scoped=true"
import script from "./SLBreakup.vue?vue&type=script&lang=js"
export * from "./SLBreakup.vue?vue&type=script&lang=js"
import style0 from "./SLBreakup.vue?vue&type=style&index=0&id=6a12d0bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12d0bc",
  null
  
)

export default component.exports